import React, { useState,useEffect }from 'react'

import { fetchCall } from "../../common/FetchHelpers";
import DateUtil from "../../common/dateUtil";
import LoadingComp from "../common/LoadingComp";

import DocumentSearchCriteria from './DocumentSearchCriteria'
import DocumentGrid from './DocumentGrid'
import DocumentDetailComp from './DocumentDetailComp';

const DocumentSearch = (props)=> {

    const searchUrl = "api/document/search";
    const detailUrl = "api/document/details/";

    let initFromDate = new Date(new Date());
    initFromDate.setDate(initFromDate.getDate() - 90);

    const fromDateStr = DateUtil.toIsoStrDate(initFromDate);

    const initFormData = {
        title: "",
        description: "",
        fromDate: fromDateStr,
        toDate: DateUtil.toIsoStrDate(new Date()),
        reqStatus: "APPROVED,PENDING,REJECTED",
    };

    const [reloadResult, setReloadResult] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState(initFormData);

    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState({});

    const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });

    const searchItems = (jsonData) => {
        setLoading(true);
        setSearchCriteria(jsonData);


        const fetchConfig = {
          method: "POST",
          cache: "no-cache",
          headers: {
              "Content-Type": "application/json"
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify(jsonData),
        }

        fetchCall(searchUrl, fetchConfig)
          .then((result)=>{
            setDataFrame({ startIndex: 0, limit: 10 });
            setItems(result);
            setLoading(false);
            setShowResult(true);
            setReloadResult(false);

          },
          (err)=>{
            setLoading(false);
            console.log(err);
            setShowError(true);

          }
        );
      };




    const onSearch = (criteria) => {
        setShowResult(false);
        searchItems(criteria);
    };



    const detailClickHandler = (id) => {
        setShowResult(false);
        setLoading(true);
        const url = detailUrl + id;

        fetchCall(url)
          .then((result)=>{
            result.formData = JSON.parse(result.formData);
            if(result.templateStr){
              result.template = {};
              result.template.templateStr = result.templateStr;
            }
            
                          
            setLoading(false);
            setCurrentItem(result);
            setShowDetail(true);

          },
          (err)=>{
            setLoading(false);
            setShowError(true);
          }
        );
      };



      const handleClose=()=>{
        setShowDetail(false);

      };


      useEffect(()=>{
        props.showingDetail(showDetail);
      },[showDetail])

    useEffect(() => {
        searchItems(initFormData);
        if(props.docId){
          detailClickHandler(props.docId);
        }
      }, []);


      useEffect(() => {
        if(props.docId){
          detailClickHandler(props.docId);
        }
      }, [props.t]);



    return (
        <div>

            {!showDetail && (
              <>
              <DocumentSearchCriteria onSearch={onSearch}/>
              <DocumentGrid items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler}/>
            </>
            )}

            {showDetail && <DocumentDetailComp editorItem={currentItem} handleUpdate={props.handleUpdate} handleClose={handleClose}/>}

            {loading && <LoadingComp />}

        </div>
    )
}

export default DocumentSearch
